/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import {
  Dialog,
  FilledButton,
  type NeedleTime,
  Popover,
  TimePicker,
} from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = () => {
  const [selectedTime, setSelectedTime] = useState<NeedleTime>();

  return (
    <Dialog isOpen={true} aria-label="Dialog">
      <Dialog.Header>
        Using Time Picker inside a popover in a dialog
      </Dialog.Header>
      <Dialog.Description className="n-flex n-flex-col n-gap-token-32">
        <Popover>
          <Popover.Trigger hasButtonWrapper>
            <FilledButton>Open Popover</FilledButton>
          </Popover.Trigger>
          <Popover.Content className="n-p-token-16">
            <TimePicker
              label="Select Time"
              value={selectedTime}
              onChange={(time) => setSelectedTime(time)}
              htmlAttributes={{ id: 'time-picker-input' }}
            />
          </Popover.Content>
        </Popover>
      </Dialog.Description>
    </Dialog>
  );
};

export default Component;
